export default __webpack_public_path__ + "static/media/ciliegia.596577da.mp3";